<template>
    <div style="max-width:480px;">
        <div class="wxOauthResult-bg">
            
        </div>
        <div class="wxOauthResult-loading">
            <div>
                <img src='../../../static/wxOauth/wxOauthLogin.gif' class="wxOauthResult-img"/>
            </div>
            <div class="wxOauthResult-span">微信授权登录中</div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'
export default {
  data(){
      return {
          isWXBrowser:typeof WeixinJSBridge == "undefined"?false:true,
          redirect:api.getDomainURL(),
          code:''
      }
  },
  activated() {
      //检查微信浏览器环境
      //this.checkWXBrowser();
      //获取跳转链接
      this.redirect=this.$route.query.redirect;
      this.code=this.$route.query.code;
      if(typeof this.redirect=="undefined"||this.redirect.length==0||this.redirect.indexOf(api.getDomainURL())<0||typeof this.code=="undefined"){
          window.location.href=api.getDomainURL();
      }
      this.goLogin(this.code,this.redirect);
      
  },
  computed: {
    ...mapGetters([
      'g_UserInfo', 'g_loginInfo'
    ])
  },
  methods:{
      //检查微信浏览器环境
      checkWXBrowser(){
        this.isWXBrowser=typeof WeixinJSBridge == "undefined"?false:true;
        if(!this.isWXBrowser){
            window.location.href=this.redirect;
        }
      },
      goLogin(code,url){
          console.log("登录"+code+"url="+url );
          var params = new this.URLSearchParam();
          params.append('code', code)
          this.$http.post(api.LoginByWXOpenid(), params.toParam()).then((res) => {
            if (!res.Result) {
                window.alert(res.Message);
                window.location.href=url;
            }
            else {
               //登录成功
                this.SaveUserInfo(res.Data);
                var loginInfo = this.g_loginInfo
                loginInfo.Card_no = res.Data.Card_no
                this.setG_loginInfo(loginInfo)


               window.location.href=url;
            }
          })  
      },
      SaveUserInfo(result) {// 保存登录信息
        // 保存登录信息
        var UserInfo = result;

        if (UserInfo.Card_Kind_Diplay == '网上数字卡') {
            UserInfo.Card_Kind_Diplay = '数字卡';
        }

        UserInfo.OrderRefresh1 = true;
        UserInfo.OrderRefresh2 = true;
        UserInfo.OrderRefresh3 = true;

        // 保存登录信息
        this.setG_UserInfo(UserInfo);

      },
      ...mapMutations([
        'setG_UserInfo', 'setG_loginInfo'
      ]),
  }

}
</script>



<style lang="less">
@import "../../assets/theme.less";
   .wxOauthResult-bg{
       background-color:#000000;
       opacity:0.6;
       position:absolute;top:0;bottom:0;left:0;right:0;
       max-width:480px;
   } 
   .wxOauthResult-loading{
       position:absolute;
       margin-top:3rem;
       width:70%;
       left:15%;
       background-color:#FFF;
       border-radius:4px;
       z-index:999;
       opacity:1;max-width:336px;
   }
   .wxOauthResult-img{
       padding-top:20px;
       padding-bottom:20px;
       width:70%;
       margin-left:15%;
   }
   .wxOauthResult-span{
       text-align:center;
       width:100%;
       padding-bottom:20px;
       color:#333333;
       font-size:0.33rem;
   }
</style>


// WEBPACK FOOTER //
// wxOauthResult.vue?57efc2ce